"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _moment = _interopRequireDefault(require("moment"));

function getMaxMoment(dates) {
  var moments = dates.filter(function (date) {
    return !!date;
  }).map(function (date) {
    return (0, _moment["default"])(date);
  });

  if (!moments.length) {
    return null;
  }

  return _moment["default"].max(moments);
}

module.exports = getMaxMoment;